import React from 'react'
import PropTypes from 'prop-types'
import {
  SCROLL_FADE_HEIGHT_GRID,
  ScrollFadeBottom,
  ScrollFadeRight,
} from './bulkOrderScrollFade.styles'

/** Bottom/right edge fades. Top fade is owned by sticky headers via onScrollFadeChange. */
const ScrollFadeOverlays = ({
  fade,
  variant,
  rightVariant,
  height = SCROLL_FADE_HEIGHT_GRID,
  topOffset,
}) => (
  <>
    <ScrollFadeBottom $visible={fade.bottom} $variant={variant} $height={height} />
    <ScrollFadeRight
      $visible={fade.right}
      $variant={rightVariant || variant}
      $height={height}
      $topOffset={topOffset}
    />
  </>
)

ScrollFadeOverlays.propTypes = {
  fade: PropTypes.shape({
    top: PropTypes.bool,
    bottom: PropTypes.bool,
    right: PropTypes.bool,
  }).isRequired,
  variant: PropTypes.oneOf(['light', 'dark']).isRequired,
  rightVariant: PropTypes.oneOf(['light', 'dark']),
  height: PropTypes.string,
  topOffset: PropTypes.string,
}

export default ScrollFadeOverlays
